import { UPDATE_SCALP_CAMERA_OPTION, GET_SCALP_CAMERA_GUIDE } from '../constants';
import { determineUserAgent } from '../../utils';

const initialState = {
  isSelectedCameraOption: '',
  scalpCameraGuide: {},
};

/**
 * Reducers
 */
export default (state = initialState, { type, payload }) => {
  switch (type) {
    // スカルプカメラアプリ使用可否を更新する
    case UPDATE_SCALP_CAMERA_OPTION:
      const { isSelectedCameraOption } = payload;
      return {
        ...state,
        isSelectedCameraOption,
      };
    // スカルプカメラ・ダウンロードマニュアルを取得する
    case `${GET_SCALP_CAMERA_GUIDE}_PENDING`:
      return state;
    case `${GET_SCALP_CAMERA_GUIDE}_FULFILLED`:
      const scalpCameraGuide = payload;
      const os = determineUserAgent().isIOS ? 'iOs' : determineUserAgent().isAndroid ? 'android' : null;
      return {
        ...state,
        scalpCameraGuide: scalpCameraGuide[os],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/scalpCameraOption.js